import store from '@/store';
import siteConfigService from '@/services/site.config.service';
import Logger from '@/utils/logger.utils';
import { StorageItemSiteInfo } from '@/entities/storage.items';
import storageService from '@/services/storage.service';
import { Language } from '@/entities/site.configuration';
import { loginService } from '@/services/login.service';
import BrowserService from '@/services/browser.service';
import { DEVICE } from '@/entities/device';
import { commonService, StringUtils, detectorService as detectorServiceCore, UserInfoContext, userService } from '@ol/ol-ui-core';
import { ssoService } from './sso.service';


export default class DetectorService {
  private static monitorHasBeenSetup: boolean = false;
  private static deviceHasBeenChecked: boolean = false;
  private static monitorHasBeenSetupFunc: any;
  private static monitorSiteConfigurationsChangedFunc: any;
  public static loginPageUrl = process.env.VUE_APP_LOGIN_PAGE_URL || '/stdpl/home.html';
  private static orgSelectPageUrl = process.env.VUE_APP_ORG_SELECTOR_PAGE_URL || '/stdpl/home2.html';
  public static resetLanguageCodeActionName: string = 'mainModule/resetLanguageCode';
  public static resetDeviceActionName: string = 'mainModule/resetDevice';

  public static async checkAuth(): Promise<void> {
    const isLoggedIn: boolean = await loginService.isLoggedIn();
    const hasCurrentOrg: boolean = await loginService.hasCurrentOrg();
    const plId: number = await storageService.getPrivateLabelId();

    const device: Array<DEVICE> = BrowserService.getDevice();
    const isIOSAppShell = device.includes(DEVICE.IOS_APP_SHELL);

    if (!isLoggedIn) {
      const hasSSOToken:boolean = await userService.hasSsoToken(plId);

      if (!hasSSOToken) {
        await ssoService.saveSSOTokenFromLoginContext();
      }
    }

    if (!isLoggedIn && store.getters['mainModule/pageContext'].requireLogin) {
      let shouldRedirect = true;
      if (isIOSAppShell) {
        Logger.info('#####IOS_APP_SHELL######');
        Logger.info(window.location.href);
        if (document.querySelector('[templatepagecode="OKTA_USER_CREATION_CONFIRMATION"]')) {
          shouldRedirect = false;
        }
      }
      if (shouldRedirect) {
        try {
          await commonService.getOrGenerateCommonProperties(plId, 0, null, null, false);
        } catch (e) { Logger.debug(e); }
        window.location.href = StringUtils.setParamValue(DetectorService.loginPageUrl, 'plg', window.encodeURIComponent(window.location.href));
      }
    } else if (!hasCurrentOrg && store.getters['mainModule/pageContext'].requireCurrentOrg && !store.getters['mainModule/isSingleOrg']) {
      window.location.href = DetectorService.orgSelectPageUrl;
    }
  }

  public static async checkSupportedBrowserLanguage(): Promise<boolean> {
    const browserSupportedLanguage: Language = await siteConfigService.getSupportedBrowsertLanguage();
    if (browserSupportedLanguage.languageCode === 'ENGLISH') {
      browserSupportedLanguage.languageCode = 'en';
    }
    const storageItemSiteInfo: StorageItemSiteInfo = await storageService.getSiteInfo();
    let languageChanged: boolean = false;
    if (!!browserSupportedLanguage && !!storageItemSiteInfo && browserSupportedLanguage.languageCode !== storageItemSiteInfo.languageCode) {
      languageChanged = true;
    }
    if (!storageItemSiteInfo || !storageItemSiteInfo.languageCode) {
      languageChanged = true;
    }
    if (languageChanged) {
      await storageService.saveLanguageCode(browserSupportedLanguage.languageCode);
      Logger.info(`browserSupportedLanguage = ${browserSupportedLanguage}`);
      Logger.info(`old languageCode = ${browserSupportedLanguage.languageCode}`);
      await store.dispatch(DetectorService.resetLanguageCodeActionName, browserSupportedLanguage.languageCode);
      return true;
    }
    return false;
  }

  private static async checkDevice(): Promise<void> {
    if (!DetectorService.deviceHasBeenChecked) {
      const device: Array<DEVICE> = BrowserService.getDevice();
      await store.dispatch(DetectorService.resetDeviceActionName, device);
      DetectorService.deviceHasBeenChecked = true;
    }
  }

  private static async checkApp(): Promise<void> {
    await DetectorService.checkDevice();
    await DetectorService.checkAuth();
    if (!BrowserService.browserLanguageNotAvailableInJS()) {
      const languageChanged: boolean = await DetectorService.checkSupportedBrowserLanguage();
    }
  }

  private static async checkSiteConfigurations(): Promise<void> {
    const plId: number = await storageService.getPrivateLabelId();
    const orgId: number = await userService.getCurrentOrgId(plId);
    await detectorServiceCore.clearCacheIfNeeded(plId, orgId);
  }

  public static async monitor(): Promise<void> {
    localStorage.removeItem('isDoingSingleSignOut');
    if (!DetectorService.monitorHasBeenSetup) {
      await DetectorService.checkApp();
      detectorServiceCore.addSiteConfigurationsChangeListener();
      DetectorService.monitorHasBeenSetupFunc = window.setInterval(DetectorService.checkApp, 5000);
      DetectorService.monitorSiteConfigurationsChangedFunc = window.setInterval(DetectorService.checkSiteConfigurations, 1800 * 1000);
    }
    window.addEventListener('storage', (e) => {
      e.preventDefault();
      if (e.key === 'isDoingSingleSignOut' && e.newValue === 'true') {
        DetectorService.stopMonitor();
      }
    });
    DetectorService.monitorHasBeenSetup = true;
  }

  public static async stopMonitor(): Promise<void> {
    window.clearInterval(DetectorService.monitorHasBeenSetupFunc);
    window.clearInterval(DetectorService.monitorSiteConfigurationsChangedFunc);
    detectorServiceCore.removeAllListeners();
    DetectorService.monitorHasBeenSetup = false;
  }
}
